/**
 * Mirrors NodeClaimAuthorization.NormalizeSerial (Domain) exactly: strip hyphens and
 * spaces, trim, uppercase. The console compares an operator's typed serial against the
 * serial the server resolved, so if these two normalizations disagreed the console would
 * show "same hardware, safe to re-arm" for hardware the claim path will refuse.
 */
export const normalizeSerial = (serial: string | null | undefined): string => {
    if (!serial) return '';
    return serial.replace(/-/g, '').replace(/ /g, '').trim().toUpperCase();
};

/** NodeId.Create: exactly 8 alphanumeric characters, uppercased. */
export const NODE_ID_LENGTH = 8;

export const isValidNodeId = (nodeId: string | null | undefined): boolean =>
    !!nodeId && new RegExp(`^[a-zA-Z0-9]{${NODE_ID_LENGTH}}$`).test(nodeId.trim());

export const normalizeNodeId = (nodeId: string | null | undefined): string =>
    (nodeId ?? '').trim().toUpperCase();

/**
 * The node ID always comes from the hardware serial: its last 8 characters, uppercased
 * (#1652, design D5). The server refuses a claim whose arming breaks this (#1655), and
 * the node refuses a key for any other ID, so the arm page derives it rather than asking
 * for it (#1680). Empty when the serial is too short to carry one.
 */
export const nodeIdFromSerial = (serial: string | null | undefined): string => {
    const s = normalizeSerial(serial);
    return s.length >= NODE_ID_LENGTH ? s.slice(-NODE_ID_LENGTH) : '';
};
